import { cn } from '@repo/ui/lib/utils'
import { Loader2Icon } from 'lucide-react'

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <Loader2Icon
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      role="status"
      {...props}
    data-sentry-element="Loader2Icon" data-sentry-component="Spinner" data-sentry-source-file="spinner.tsx" />
  )
}

export { Spinner }
